module.exports = __webpack_public_path__ + "static/img/icon_geren_disable.350c6798.png";